module.exports = __webpack_public_path__ + "img/send_money_color.fb5f0e56.svg";